import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEye,
  faShoppingCart,
  faComments,
  faUsers,
  faMapMarkerAlt,
  faBuilding,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom"; // Import Link from react-router-dom
import NavigationBar from "../layout/NavigationBar"; // Assuming you have a navigation bar
import Footer from "../layout/footer"; // Assuming you have a footer
import LeaderboardChart from "./LeaderboardChart"; // Import the chart component
import RankingChart from "./RankingChart";

function Dashboard1() {
  const [data, setData] = useState(null); // For storing the fetched stats
  const [loading, setLoading] = useState(true); // Loading state for API requests
  const [error, setError] = useState(null); // Error state for error handling
  const [leaderboardData, setLeaderboardData] = useState([]); // State for leaderboard data
  const [totalPages, setTotalPages] = useState(5); // State for leaderboard data
  const [currentPage, setCurrentPage] = useState(); // State for leaderboard data
  const itemsPerPage = 10;
  // Fetch data function to get stats
  const fetchData = async (page = 1, limit = 10) => {
    try {
      const response = await axios({
        method: "POST",
        url: process.env.REACT_APP_APIURL, // Ensure this is set in your .env file
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          environment: "live",
          apikey: process.env.REACT_APP_APIKEY, // Use environment variables for sensitive data
          secret: process.env.REACT_APP_SECRET, // Same as above
          method: "getStats", // This should match your backend method name
          module: "user",
          index: page, // Pass the current page
          limit,
        }),
      });

      const result = response.data;
      if (result.statusCode === 200) {
        setData(result.result); // Assuming the data you want is in the 'result' field
        setLeaderboardData(result.result.leaderboard);
        setTotalPages(result.result.totalPages); // Set total pages from response
        setCurrentPage(result.result.currentPage);
      } else {
        setError("Failed to fetch data");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setError("Error fetching data");
    } finally {
      setLoading(false); // Set loading state to false after fetching data
    }
  };

  useEffect(() => {
    fetchData(); // Call the fetchData function when the component mounts
  }, []); // Empty array ensures it runs only once when the component mounts

  // Render loading or error state
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }
  const handlePageChange = (newPage) => {
    // Fetch new leaderboard data based on the new page
    fetchData(newPage, 10);
  };
  return (
    <>
      <div className="wrapper">
        <header>
          <NavigationBar />
        </header>

        <div className="content-wrapper">
          {/* Content Header (Page header) */}
          <div className="content-header">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-sm-6">
                  <h1 className="m-0 txt_lft">Dashboard</h1>
                </div>
                {/* /.col */}
                {/* <div class="col-sm-6">
      <ol class="breadcrumb float-sm-right">
        <li class="breadcrumb-item"><a href="#">Home</a></li>
        <li class="breadcrumb-item active">Page 1</li>
      </ol>
    </div> */}
              </div>
              {/* /.row */}
            </div>
            {/* /.container-fluid */}
          </div>
          {/* /.content-header */}
          {/* Main content */}
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-3 mb-4">
                  <a href="/users" target="_blank" className="card-link">
                    <div className="card stats_item businesses-card">
                      <div className="card-body text-center">
                        <i className="fa-solid fa-users text-warning fa-3x mb-3" />
                        <h4 className="card-title">Users</h4>
                        <h3 className="f_black">{data.totalUsers}</h3>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-4">
                  <a href="/businesses" target="_blank" className="card-link">
                    <div className="card stats_item businesses-card">
                      <div className="card-body text-center">
                        <i className="fa-solid fa-building text-danger fa-3x mb-3" />
                        <h4 className="card-title">Businesses</h4>
                        <h3 className="f_black">{data.totalBusinesses}</h3>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-4">
                  <a href="/geotags" target="_blank" className="card-link">
                    <div className="card stats_item businesses-card">
                      <div className="card-body text-center">
                        <i className="fa-solid fa-location-dot text-info fa-3x mb-3" />
                        <h4 className="card-title">Active Geotags</h4>
                        <h3 className="f_black">{data.totalGeotags}</h3>
                      </div>
                    </div>
                  </a>
                </div>
                <div className="col-12 col-md-6 col-lg-3 mb-4">
                  <a href="/hunted" target="_blank" className="card-link">
                    <div className="card stats_item businesses-card">
                      <div className="card-body text-center">
                        <i className="fa-solid fa-eye text-success fa-3x mb-3" />
                        <h4 className="card-title">Hunted</h4>
                        <h3 className="f_black">{data.totalOpenedGeotags}</h3>
                      </div>
                    </div>
                  </a>
                </div>
                {/* <div class="col-12 col-md-6 col-lg-3 mb-4">
    <a href="#" target="_blank" class="card-link">
      <div class="card stats_item businesses-card">
        <div class="card-body text-center">
          <i class="fa-solid fa-trophy f_purple fa-3x mb-3"></i>
          <h4 class="card-title">Leaderboard</h4>
          <h3 class="f_black">20</h3>
        </div>
      </div>
    </a>
  </div> */}
              </div>
              <div className="row justify-content-center">
                <div className="col-lg-6">
                  <div className="card stats_item businesses-card">
                    <div className="card-title p-2 text-center bg_lightblue">
                      <span className="f_sz26 f_white">
                        Leaderboard{" "}
                        <span className="f_sz16 f_white">(Top 50 hunters)</span>
                      </span>
                    </div>
                    <div className="card-body text-center">
                      <div className="table-responsive">
                        <table
                          id="leaderboard"
                          width="100%"
                          className="table table-striped leaderboard_tbl"
                        >
                          <tbody>
                            {/*  */}
                            {leaderboardData.map((user,index) => (
                              <tr>
                                <td className="align-middle">
                                  <span className="lb_count"> {(currentPage - 1) * itemsPerPage + index + 1}</span>
                                </td>
                                <td className="align-middle txt_lft">
                                  <span className="lb_hunterimg">
                                    <img
                                      src={user.profileImage}
                                      alt={user.name}
                                      className="img-circle"
                                    />
                                  </span>
                                  <span className="f_sz16 ml-2">
                                    {user.name}
                                  </span>
                                </td>
                                <td className="align-middle">
                                  <span className="lb_geotagimg d-inline-flex align-items-center">
                                    <span className="f_sz26 fwt_600 mr-3">
                                      {user.count}
                                    </span>
                                    <img src="assets/img/hunted.png" />
                                  </span>
                                </td>
                                {/* <td class="align-middle"><a href="#"><i class="fa-solid fa-eye f_sz18 f_purple"></i></a></td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <nav aria-label="Page navigation example">
                          <ul className="pagination justify-content-center mb-0">
                            <li
                              className={`page-item ${
                                currentPage === 1 ? "disabled" : ""
                              }`}
                            >
                              <a
                                className="page-link"
                                onClick={() => fetchData(currentPage - 1)}
                                href="#"
                                tabIndex={-1}
                              >
                                Previous
                              </a>
                            </li>
                            {[...Array(totalPages)].map((_, index) => (
                              <li
                                key={index}
                                className={`page-item ${
                                  currentPage === index + 1 ? "active" : ""
                                }`}
                              >
                                <a
                                  className="page-link"
                                  onClick={() => fetchData(index + 1)}
                                  href="#"
                                >
                                  {index + 1}
                                </a>
                              </li>
                            ))}
                            <li
                              className={`page-item ${
                                currentPage === totalPages ? "disabled" : ""
                              }`}
                            >
                              <a
                                className="page-link"
                                onClick={() => fetchData(currentPage + 1)}
                                href="#"
                              >
                                Next
                              </a>
                            </li>
                          </ul>
                        </nav>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* /.row */}
            </div>
            {/* /.container-fluid */}
          </div>
          {/* /.content */}
        </div>

        <Footer />
      </div>
    </>
  );
}

export default Dashboard1;
